module.exports = __webpack_public_path__ + "img/BigWechat.1580ba1b.png";